export default __webpack_public_path__ + "static/media/eleanor_stay.849ae4a3.png";